// ==========================================================================
// Base
// ==========================================================================

/* global $ */

"use strict";


//Prevent # anchors jumping page to top
$('a[href="#"]').click(function (e) {
    e.preventDefault();
});


/*
if (typeof DEVELOPMENT !== "undefined" && DEVELOPMENT) {
    $("body").addClass("debug");
}
*/


document.addEventListener('DOMContentLoaded', function() {
    const menus = document.querySelectorAll('.navbar-burger');
    const dropdowns = document.querySelectorAll('.navbar-menu');

    if (menus.length && dropdowns.length) {
        for (var i = 0; i < menus.length; i++) {
            menus[i].addEventListener('click', function() {
                for (var j = 0; j < dropdowns.length; j++) {
                    dropdowns[j].classList.toggle('hidden');
                }
            });
        }
    }
});

$(function () {
    var count = 0;
    var wordsArray = ["builders and developers", "self builders"];
    setInterval(function () {
        count++;
        $(".HeroBlock__headline span").fadeOut("slow", function () {
            $(this).text(wordsArray[count % wordsArray.length]).fadeIn("slow");
        });
    }, 3500);
});



document.addEventListener("DOMContentLoaded", function() {
    // Target the form with the ID 'newsletter-footer'
    var form = document.getElementById('newsletter-footer');
    
    // Check if the form exists to prevent errors
    if (form) {
      // Select the reCAPTCHA element
      var recaptcha = form.querySelector('.g-recaptcha');
      
      // Function to unhide reCAPTCHA
      function showRecaptcha() {
        recaptcha.style.display = 'block'; // Unhide the reCAPTCHA
      }
  
      // Attach focus event to all input fields in the 'newsletter-footer' form
      var inputs = form.querySelectorAll('.input-text');
      inputs.forEach(function(input) {
        input.addEventListener('focus', function() {
          showRecaptcha();
        }, { once: true }); // Use { once: true } to show reCAPTCHA only once
      });
    }
  });
  